import React from 'react';
import { Dropdown } from 'antd';
import { Download } from 'lucide-react';
import { exportToExcel, exportToCSV, exportToPDF } from '../../lib/exportUtils';

/**
 * Reusable export dropdown button
 * @param {Array} data - Array of objects to export
 * @param {string} filename - Base filename
 * @param {Array} pdfColumns - [{title, dataKey}] for PDF table (optional)
 * @param {string} pdfTitle - PDF report title (optional)
 */
const ExportButton = ({ data, filename = 'export', pdfColumns, pdfTitle }) => {
  const items = [
    {
      key: 'excel',
      label: 'Export as Excel',
      onClick: () => exportToExcel(data, filename),
    },
    {
      key: 'csv',
      label: 'Export as CSV',
      onClick: () => exportToCSV(data, filename),
    },
  ];

  if (pdfColumns) {
    items.push({
      key: 'pdf',
      label: 'Export as PDF',
      onClick: () => exportToPDF(pdfColumns, data, pdfTitle || filename, filename),
    });
  }

  if (!data || data.length === 0) return null;

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <button className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium text-gray-500 bg-gray-100 hover:bg-gray-200 transition-colors">
        <Download size={14} />
        Export
      </button>
    </Dropdown>
  );
};

export default ExportButton;
